import React, { useState } from 'react';

import { defaultColorPalette } from '@aline/common';
import clsx from 'clsx';
import { useField } from 'formik';
import { ColorSelectMenu } from 'src/components';
import { DownArrowIconSize12 } from 'src/components/icons/DownArrowIconSize12';
import { makeStyles } from 'tss-react/mui';

import { useInputStyles } from './useInputStyles';

const useStyles = makeStyles()(theme => ({
  colorCircle: {
    border: `1px solid ${theme.appColors.rule}`,
    borderRadius: 12,
    height: 18,
    width: 18,
  },
  inputBox: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 8px',
  },
}));

interface FormikColorSelectProps {
  fieldName: string;
  onSelectChange?: (value: string) => void;
}

export function FormikColorSelect({
  fieldName,
  onSelectChange,
}: FormikColorSelectProps): JSX.Element {
  const inputRef = React.useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [field, , fieldHelper] = useField<string | undefined>(fieldName);
  const { classes: inputClasses } = useInputStyles({ isOpen: isMenuOpen });
  const { classes } = useStyles();

  function onSelectColor(_: unknown, color: string | null) {
    fieldHelper.setValue(color ?? 'transparent');
    if (onSelectChange) onSelectChange(color ?? 'transparent');
    setIsMenuOpen(false);
  }

  return (
    <>
      <div
        ref={inputRef}
        className={clsx(inputClasses.inputBox, classes.inputBox)}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <div>
          <div className={classes.colorCircle} style={{ backgroundColor: field.value }} />
        </div>
        <div>
          <DownArrowIconSize12 />
        </div>
      </div>
      <ColorSelectMenu
        hasTransparentOption
        anchorEl={() => inputRef.current!}
        colorColumns={defaultColorPalette}
        handleClose={() => setIsMenuOpen(false)}
        open={isMenuOpen}
        selectColor={onSelectColor}
        selectedColor={field.value ?? null}
      />
    </>
  );
}
